import { render, staticRenderFns } from "./Responded.vue?vue&type=template&id=5ed2bab6&scoped=true"
import script from "./Responded.vue?vue&type=script&lang=js"
export * from "./Responded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2bab6",
  null
  
)

export default component.exports